import styled from "styled-components";

export default styled.div`
.rich-text-editor {
    min-width: 200px;
    max-width: 800px;
    margin-bottom: 20px;
}
`;
